import {css} from 'lit';
import {unsafeCSSIcon} from "../../../styles/icons";

// language=CSS
export const audioInput =
    css`
        :host {
            display: grid;
            grid-auto-flow: row;
            position: relative;
            width: 100%;
            white-space: nowrap;
            isolation: isolate;
        }

        .recordings {
            background-color: #fff;
            box-sizing: border-box;
            box-shadow: var(--sp-default-box-shadow);
            border-radius: 3px;
            width: 100%;
            margin-top: 0.3rem;
        }
        .recordings.view-mode {
            background-color: unset;
            box-sizing: unset;
            box-shadow: unset;
            border-radius: unset;
            width: 100%;
            margin-top: 0;
        }

        .recordings.view-mode sp-audio-input-entry:not(:last-child)::part(container) {
            margin-bottom: calc(var(--sp-default-padding) / 2);
        }
        
        sp-audio-input-entry:first-of-type::part(play) {
            border-top-right-radius: 3px;
        }

        sp-audio-input-entry:last-of-type::part(play) {
            border-bottom-right-radius: 3px;
        }
        
        .container {
            position: relative;
            display: grid;
            grid-template-columns: 4rem 3rem auto 70px;
            width: 100%;
            height: 45px;
            background-color: #fff;
            border-radius: 3px;
            box-shadow: var(--sp-default-box-shadow);
        }

        .icon {
            background-image: url(${unsafeCSSIcon('microphone', { color: 'grey-dark' })});
            background-size: auto 65%;
            background-repeat: no-repeat;
            background-position: center;
            margin-left: 0.8rem;
            grid-column: 1 / 2;
            display: grid;
            place-content: center start;
        }

        .time {
            grid-column: 2 / 3;
            display: grid;
            place-content: center start;
            font-weight: bold;
        }

        .wave {
            grid-column: 3 / 4;
            margin-left: 0.1rem;
            margin-right: 1rem;
        }

        .text {
            grid-column: 1 / 4;
            padding-left: 10px;
            display: grid;
            place-content: center start;
            color: #aaa;
        }

        .button {
            grid-column: 4 / 5;
            width: 100%;
            height: 100%;
            border-bottom-left-radius: 0;
            border-top-left-radius: 0;
        }
    `;
